// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton-module_skeleton__ahyyS","pulse":"Skeleton-module_pulse__Emc0Z"};